"use strict";
exports.__esModule = true;
var get_style_1 = require("./get-style");
function getHeight(el, defaultValue) {
    var width = get_style_1["default"](el, 'width', defaultValue);
    if (width === 'auto') {
        width = el.offsetWidth;
    }
    return parseFloat(width);
}
exports["default"] = getHeight;
//# sourceMappingURL=get-width.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/dom-util/lib/get-width.js
// module id = 591
// module chunks = 37